import { User } from '@auth0/auth0-react';

import { getHrisProviderForConnectionName } from './connectionNameToHrisProvider';
import { CLAIM_EXTERNAL_CONNECTION_NAME } from './parseEmbeddedFirstLoginArgs';

export const CLAIM_EXTERNAL_USER_NEEDS_SIGNUP =
  'https://my.electric.ai/external_user_needs_to_signup';

type Auth0UserWithSignupClaims = User & {
  [CLAIM_EXTERNAL_USER_NEEDS_SIGNUP]?: unknown;
  [CLAIM_EXTERNAL_CONNECTION_NAME]?: string;
};

/**
 * Decide whether a login should enter the JIT first-login signup flow
 * (EmbeddedFirstLogin) instead of normal app initialization.
 *
 * We deliberately do NOT gate on iframe embedding: some HRIS connections
 * (e.g. isolved) launch top-level rather than in an iframe. The signup claim
 * is set by a post-login Action in a separate repo (auth0-management) that
 * this frontend doesn't control, so we additionally require the connection to
 * resolve to a known HRIS provider — the same allowlist EmbeddedFirstLogin
 * itself enforces. An unrecognized/future connection therefore falls through
 * to normal init instead of dead-ending on InitFailedState.
 */
export const shouldTriggerFirstLoginSignup = (
  auth0User: User | null | undefined
): boolean => {
  if (!auth0User) {
    return false;
  }
  const user = auth0User as Auth0UserWithSignupClaims;
  if (!user[CLAIM_EXTERNAL_USER_NEEDS_SIGNUP]) {
    return false;
  }
  const connectionName = user[CLAIM_EXTERNAL_CONNECTION_NAME];
  return (
    typeof connectionName === 'string' &&
    !!getHrisProviderForConnectionName(connectionName)
  );
};
